import React, {useEffect, useState} from 'react';
import SelectHtmlTag from "../../../content/components/rich-text-editor/select-html-tag";
import {COLLECTION_META_TYPE_LIST} from "../../../content/constants/content.constant";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import {processMetaLineTypeChange} from "../../utils/product-util";

const CollectionMetaList = ({
                                metaLines = [],
                                handleCollectionDetailChange = undefined
                            }) => {

    const changeMetaLineType = (metaLine, newType) => {
        processMetaLineTypeChange(metaLine, newType);

        if (handleCollectionDetailChange) {
            handleCollectionDetailChange();
        }
    }

    return (
        <>
            <div className={'mt-2 px-2 w-fit'}>
                {metaLines?.map((metaLine, metaLineIndex) => (
                    <div key={`metaLine-${metaLineIndex}`}>
                        <div
                            className={`w-full mb-2 p-3 border border-sky-400 bg-sky-50 shadow-lg rounded-xl`}>

                            <div className={'flex items-center justify-between'}>
                                <div className={`w-full`}>
                                    {metaLine?.isMeta &&
                                        <div
                                            className={`flex justify-start text-gray-900 font-bold text-sky-500`}>
                                            <div
                                                className={''}>{metaLine.metaLabel}</div>
                                        </div>
                                    }
                                    <div
                                        className={`flex justify-start text-gray-900 ${metaLine.isSection ? 'font-bold text-pink-500' : ''}`}>
                                        <div className={''}>{metaLine.text}</div>
                                    </div>

                                    <div
                                        className={'flex justify-between items-center'}>
                                        {!metaLine.isSection &&
                                            <SelectHtmlTag
                                                contentLine={metaLine}
                                                contentLineIndex={metaLineIndex}
                                                elementTypeList={COLLECTION_META_TYPE_LIST}
                                                changeContentLineType={(metaLineIndex, newTypeKey) => {
                                                    changeMetaLineType(metaLine, newTypeKey);
                                                }}/>
                                        }

                                        <div
                                            className={'text-right flex items-center justify-end min-w-fit'}>

                                            <div className={'m-1'}>
                                                <CopyDataToClipboard
                                                    sizeClass={'px-1 py-1'}
                                                    value={metaLine?.text}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

export default CollectionMetaList
